
import { ICustomField, ICustomFieldConfig, CustomFieldEntityType, UpdateCustomFieldValueDto, UpdateCustomFieldConfigDto } from 'src/services/custom-fields/custom-field.types';

import { rootApi } from '../rootApi';
import { APIResponse } from '../api.types';

export const customFieldsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({

    // configs
    getConfigByEntityType: builder.query<ICustomFieldConfig[], { entityType: CustomFieldEntityType }>({
      query: (data) => ({
        url: `/custom-fields/${data.entityType}/configs`
      }),
      providesTags: (result, error, { entityType }) => [{ type: 'CustomFieldConfigs', id: entityType }],
    }),

    // How many records hold each multi-select option, so the settings screen can tell an admin what
    // archiving or deleting one would actually touch.
    getOptionUsage: builder.query<Record<string, number>, { entityType: CustomFieldEntityType }>({
      query: (data) => ({
        url: `/custom-fields/${data.entityType}/option-usage`
      }),
      providesTags: (result, error, { entityType }) => [{ type: 'CustomFieldConfigs', id: entityType }],
    }),

    updateCustomFieldConfig: builder.mutation<ICustomFieldConfig[], { entityType: CustomFieldEntityType; data: UpdateCustomFieldConfigDto }>({
      query: ({ entityType, data }) => ({
        url: `/custom-fields/${entityType}/configs`,
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error, { entityType }) => [{ type: 'CustomFieldConfigs', id: entityType }],
    }),

    // custom fields
    getCustomFieldsForEntity: builder.query<ICustomField[], { entityType: CustomFieldEntityType; entityId: string }>({
      query: ({ entityType, entityId }) => ({
        url: `/custom-fields/${entityType}/${entityId}/fields`,
      }),
      providesTags: (result, error, { entityType, entityId }) => [{ type: 'CustomFields', id: `${entityType}-${entityId}` }],
    }),
    updateCustomFieldValue: builder.mutation<APIResponse, { entityType: CustomFieldEntityType; entityId: string; data: UpdateCustomFieldValueDto }>({
      query: ({ entityType, entityId, data }) => ({
        url: `/custom-fields/${entityType}/${entityId}/fields`,
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error, { entityType, entityId }) => [{ type: 'CustomFields', id: `${entityType}-${entityId}` }],
    }),
  }),
});


export const {
  useGetConfigByEntityTypeQuery,
  useLazyGetConfigByEntityTypeQuery,
  useGetOptionUsageQuery,
  useUpdateCustomFieldConfigMutation,

  useGetCustomFieldsForEntityQuery,
  useUpdateCustomFieldValueMutation,
} = customFieldsApi;
